import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, timeAgo } from "@/lib/api";
import { Button } from "@/components/ui/button";

const LABEL = { hate_speech: "Hate speech", propaganda: "Propaganda", political_opinion: "Political opinion" };

export const ContentFlags = () => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/content/flags").then((r) => setD(r.data)).catch(() => setD({ flags: [] }));
  useEffect(() => { load(); }, []);
  const decide = async (id, decision) => {
    try { const { data } = await api.post(`/admin/content/flags/${id}`, { decision }); toast.success(decision === "keep" ? "Kept" : data.removed ? "Removed" : "Marked as removed (item already gone)"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!d) return null;
  return (
    <section className="space-y-3" data-testid="admin-content-flags">
      <div><h2 className="text-2xl">Needs a human decision <span className="text-base text-slate-500">({d.flags.length})</span></h2>
        <p className="text-sm text-slate-500">Published posts where the AI was less than {Math.round((d.threshold || 0.75) * 100)}% sure about hate speech, propaganda or political opinion. They stay visible until you decide.</p></div>
      {!d.flags.length ? <p className="surface p-5 text-sm text-slate-500" data-testid="admin-flags-empty">Nothing waiting for review.</p> : d.flags.map((f) => (
        <article key={f.id} className="surface space-y-2 p-4" data-testid={`admin-flag-${f.id}`}>
          <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
            <span className="rounded-full bg-slate-100 px-2 py-0.5 font-medium capitalize text-slate-700">{f.kind.replace("_", " ")}</span>
            <span>{f.author?.name || "Member"}{f.author?.handle ? ` @${f.author.handle}` : ""}</span><span>· {timeAgo(f.at)}</span>
            <span className="rounded-full bg-amber-50 px-2 py-0.5 text-amber-800" data-testid={`admin-flag-confidence-${f.id}`}>AI {Math.round(f.confidence * 100)}% sure · {f.ai_allowed ? "leaned allow" : "leaned block"}</span>
            {f.concerns.map((c) => <span key={c} className="rounded-full bg-rose-50 px-2 py-0.5 text-rose-700">{LABEL[c] || c}</span>)}
          </div>
          <p className="whitespace-pre-wrap text-sm text-slate-800">{f.text}</p>
          {f.reason && <p className="text-xs text-slate-500">AI note: {f.reason}</p>}
          <div className="flex gap-2">
            <Button size="sm" variant="outline" className="rounded-full" onClick={() => decide(f.id, "keep")} data-testid={`admin-flag-keep-${f.id}`}>Keep it up</Button>
            <Button size="sm" variant="destructive" className="rounded-full" onClick={() => decide(f.id, "remove")} data-testid={`admin-flag-remove-${f.id}`}>Remove</Button>
          </div>
        </article>
      ))}
    </section>
  );
};
